<script>
import { useI18n } from 'vue-i18n';

export default {
    name: 'ReleaseChecker',

    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },

    computed: {
        echoReady() {
            return !!this.$store.state.Online.$echo;
        },
    },

    watch: {
        echoReady(ready) {
            if (ready) {
                this.$echo.channel('release').listen('NewReleaseEvent', e => {
                    this.$store.commit('SET_OUT_OF_DATE');

                    this.$snackbar.open({
                        type: 'is-success',
                        message: this.translate('new_version'),
                        position: 'is-bottom-left',
                        actionText: 'Reload',
                        indefinite: true,
                        onAction: () => window.location.reload(),
                    });
                });
            }
        },
    },

    render: () => null,
};
</script>
